export enum ColumnDefinitionPredefined {
    SELECT = -2,
    ACTIONS = -1,
}